// @flow

import styled from "styled-components";

import buildColor from "../../_static/ColorPalette";

export const Table = styled.table`
  width: 100%;
  background-color: ${buildColor("white", "100")};
  font-size: 12px;
  table-layout: fixed;

  & > thead > tr {
    border-bottom: 1px solid ${buildColor("grey", "300")};
  }

  & > tbody > tr {
    border-bottom: 1px solid ${buildColor("blue", "100")};

    &:nth-child(even) {
      background-color: ${buildColor("blue_accent", "000")};
    }
  }
`;

export const Th = styled.th`
  width: ${(props) => (props.first ? "48px" : "auto")};
  height: 40px;
  padding: 8px;
  background-color: ${buildColor("blue", "100")};
  text-transform: uppercase;
  text-align: ${(props) => (props.first ? "center" : "left")};
  vertical-align: ${(props) => (props.first ? "bottom" : "middle")};
  font-weight: normal;

  & > strong {
    display: block;
    font-weight: bold;
  }
`;

export const Td = styled.td`
  width: ${(props) => (props.first ? "48px" : "auto")};
  text-align: ${(props) => (props.first ? "center" : "left")};
  height: 40px;
  padding: 0 8px;
`;

export const Runner = styled.span`
  display: inline-flex;
  align-items: center;
  width: 16px;
  height: 16px;
`;
